<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-col v-if="!item" cols="12">
        <v-card flat color="transparent">
          <v-card-text class="py-0">
            <v-sheet color="transparent">
              <v-row no-gutters style="height:30px;" align="center">
                <v-col cols="12" align="end">
                  <v-btn x-small depressed color="error" outlined class="hidden-xs-only no-print mr-1" style="font-size: 0.625rem;" @click="retrieve()">更新</v-btn>
                  <v-btn x-small depressed color="green" outlined class="hidden-xs-only no-print mr-1" style="font-size: 0.625rem;" @click="value = !value">{{ value ? '数値' : '%' }}</v-btn>
                  <v-btn x-small depressed color="grey" outlined class="hidden-xs-only no-print" style="font-size: 0.625rem;" @click="setting = !setting">設定</v-btn>
                </v-col>
              </v-row>
              <v-row align="center" justify="center" style="height:30px;" class="px-2 b-B-GREY-DARK" no-gutters>
                <v-col v-for="(header, index) in headers" :cols="header.width"  :align="header.header_align" class="pa-0" :key="header.key">
                  <v-sheet v-if="header.valid" class="pa-0 text-hidden" color="transparent">
                    <span @click="onSort(index)" class="pa-0" @mouseleave="onMouse(index, false)" style="font-size:0.625rem;">{{ header.title }}</span>
                    <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                  </v-sheet>
                  <v-sheet v-else class="pa-0 text-hidden" color="transparent">
                    <span style="font-size: 0.625rem;">{{ header.title }}</span>
                  </v-sheet>
                </v-col>
              </v-row>
             <v-row align="start" no-gutters class="overflow-y-auto" :style="contentsHeight">
                <v-col cols="12" class="pa-0" align="center">
                  <v-expansion-panels accordion class="pa-2" v-model="panel">
                    <v-expansion-panel
                      v-for="(item,i) in myItems"
                      :key="i"
                      @click="clickHeader(item)"
                    >
                      <v-expansion-panel-header class="pa-0 px-2">
                        <v-row align="center" style="height: 30px;" no-gutters>
                          <v-col v-for="(header) in headers" :cols="header.width" class="py-0 px-1" :align="header.align" :key="header.key">
                            <span class="overflow-text-hidden" style="font-size: 0.625rem;">{{ header.prefix + item[header.key] + header.suffix }}</span>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row align="center" class="pb-1" no-gutters>
                          <span class="overflow-text-hidden outline" style="font-size: 0.625rem;">{{ '全校' }}</span>
                          <v-spacer></v-spacer>
                          <v-btn x-small depressed color="error" outlined class="no-print mr-2" style="font-size: 0.625rem;" @click="oneRetrieve(item)">更新</v-btn>
                          <v-btn x-small depressed color="primary" outlined @click.stop="onSelect(item, '*')" style="font-size: 0.625rem;">詳細</v-btn>
                        </v-row>
                        <template-chart-overview
                          v-if="details['*']"
                          :yyyy="yyyy"
                          :mm="mm"
                          :value="value"
                          :items="details['*']"
                        >
                        </template-chart-overview>
                        <template v-if="items[item.key].groups.length > 1">
                          <div v-for="(group, index) in items[item.key].groups" :key="index">
                            <v-row align="center" class="py-1" no-gutters>
                              <span class="overflow-text-hidden outline" style="font-size: 0.625rem;">{{ group.name }}</span>
                              <v-spacer></v-spacer>
                              <v-btn x-small depressed color="primary" outlined @click.stop="onSelect(item, group.key)" style="font-size: 0.625rem;">詳細</v-btn>
                            </v-row>
                            <template-chart-overview
                              v-if="details[group.key]"
                              :yyyy="yyyy"
                              :mm="mm"
                              :value="value"
                              :items="details[group.key]"
                            >
                            </template-chart-overview>
                          </div>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col v-if="item" cols="12" class="pa-0">
        <v-toolbar
          dense
          elevation="0"
          class="px-3 pt-2"
        >
          <v-row align="center">
            <v-col cols="4" class="py-0" align="center">
              <v-row align="center" no-gutters>
                <v-btn small icon @click="item = null" class="no-print mr-2"><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn x-small depressed :color="prev ? 'primary' : 'grey'" dark class="no-print mr-1" style="font-size: 0.625rem;" @click="prev = !prev">
                  昨年
                  <v-icon x-small>{{ prev ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </v-btn>
                <v-btn x-small depressed :color="plan ? 'green' : 'grey'" dark class="no-print mr-1" style="font-size: 0.625rem;" @click="plan = !plan">
                  目標
                  <v-icon x-small>{{ plan ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </v-btn>
                <v-btn v-if="prev || plan" x-small depressed color="green" outlined class="no-print" style="font-size: 0.625rem;" @click="value = !value">{{ value ? '数値' : '%' }}</v-btn>
              </v-row>
            </v-col>
            <v-col cols="4" class="py-0" align="end">
              <v-select
                v-if="groups.length > 2"
                :items="groups"
                item-text="name"
                item-value="key"
                v-model="group"
                dense
                hide-details
                label="教室"
                class="caption mr-3"
              >
              </v-select>
            </v-col>
            <v-col cols="4" class="py-0" align="end">
              <v-row no-gutters align="center">
                <v-spacer></v-spacer>
                <v-select
                  :items="options"
                  dense
                  hide-details
                  label="年"
                  class="caption mr-3"
                  v-model="selected"
                >
                </v-select>
                <v-sheet elevation="1" outlined @click="period = 1" class="no-print month-select">
                  <v-icon small :color="period == 1 ? 'primary' : 'grey'">mdi-numeric-1-box</v-icon>
                </v-sheet>
                <v-sheet elevation="1" outlined @click="period = 2" class="no-print month-select mr-2">
                  <v-icon small :color="period == 2 ? 'primary' : 'grey'">mdi-numeric-2-box</v-icon>
                </v-sheet>
                <v-btn small icon outlined elevation="0" color="transparent" @click.stop="onPrint()" class="print-btn mr-2">
                  <v-icon color="grey">mdi-printer</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-toolbar>
        <div class='overflow-y-auto scroll-y' :style="contentsHeight2">
          <template-dashboard
            v-if="item"
            :items="items"
            :item="item"
            :skey="skey"
            :yyyy="selected"
            :mm="mm"
            :period="period"
            :value="value"
            :group="group"
            :prev="prev"
            :plan="plan"
          >
          </template-dashboard>
        </div>
      </v-col>
    </v-row>

    <div v-if="setting">
      <v-dialog
        v-model="setting"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <dialog-settings
          :schools="schools"
          @dismissed="onDismissed"
        >
        </dialog-settings>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-container>
</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import moment from 'moment'
import { mapGetters } from 'vuex'
import * as async from 'async'
import TemplateDashboard from './TemplateDashboard.vue'
import TemplateChartOverview from './TemplateChartOverview.vue'
import DialogSettings from './DialogSettings.vue'

Vue.component('template-dashboard', TemplateDashboard)
Vue.component('template-chart-overview', TemplateChartOverview)
Vue.component('dialog-settings', DialogSettings)

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      windowSize: 'shared/windowSize'
    }),
    yyyy () {
      moment.tz.setDefault('Asia/Tokyo')
      var y = moment().year()
      var m = moment().month()
      if (m < 3) {
        y -= 1
      }
      return y
    },
    mm () {
      moment.tz.setDefault('Asia/Tokyo')
      var m = moment().month()
      return m < 3 ? m + 9 : m - 3
    },
    headers () {
      return [
        { valid: false, over: false, value: 0, title: '塾名', key: 'name_school', width: '2', header_align: 'center', align: 'start', prefix: '', suffix: '' },
        { valid: false, over: false, value: 0, title: '教室数', key: 'number_class_current', width: '1', header_align: 'center', align: 'end', prefix: '', suffix: '' },
        { valid: false, over: false, value: 0, title: '平均生徒数', key: 'number_students_per_class_current', width: '1', header_align: 'center', align: 'end', prefix: '', suffix: '' },
        { valid: false, over: false, value: 0, title: '生徒数', key: 'number_students_current', width: '1', header_align: 'center', align: 'end', prefix: '', suffix: '' },
        { valid: false, over: false, value: 0, title: '昨年', key: 'number_students_prev', width: '1', header_align: 'center', align: 'end', prefix: '', suffix: this.value ? '%' : '' },
        { valid: false, over: false, value: 0, title: '目標', key: 'number_students_plan', width: '1', header_align: 'center', align: 'end', prefix: '', suffix: this.value ? '%' : '' },
        { valid: false, over: false, value: 0, title: '問合せ平均', key: 'number_status_1', width: '1', header_align: 'center', align: 'end', prefix: '', suffix: '' },
        { valid: false, over: false, value: 0, title: '入会率', key: 'number_kpi_3', width: '1', header_align: 'center', align: 'end', prefix: '', suffix: '%' },
        { valid: false, over: false, value: 0, title: '退会平均', key: 'number_status_7', width: '1', header_align: 'center', align: 'end', prefix: '', suffix: '' },
        { valid: false, over: false, value: 0, title: 'DTS平均', key: 'number_status_9', width: '1', header_align: 'center', align: 'end', prefix: '', suffix: '' },
        { valid: false, over: false, value: 0, title: '単価平均', key: 'number_fees_0', width: '1', header_align: 'center', align: 'end', prefix: '¥', suffix: '' }
      ]
    },
    myItems () {
      var temp = []
      for (var i in this.items) {
        var students = this.students('current', this.items[i])
        var g = this.groupNumber(this.items[i])
        temp.push({
          'key': this.items[i].schools.key,
          'name_school': this.items[i].schools.name,
          'number_class_current': g,
          'number_students_per_class_current': this.studentsPerGroup(students, g),
          'number_students_current': students,
          'number_students_prev': this.students('prev', this.items[i]),
          'number_students_plan': this.students('plan', this.items[i]),
          'number_status_1': this.status(1, this.items[i], this.yyyy, this.mm).toFixed(1),
          'number_kpi_3': this.kpi(6, this.items[i], this.yyyy, this.mm),
          'number_status_7': this.status(7, this.items[i], this.yyyy, this.mm).toFixed(1),
          'number_status_9': this.status(9, this.items[i], this.yyyy, this.mm).toFixed(),
          'number_fees_0': this.fees(0, this.items[i], this.yyyy, this.mm)
        })
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    detailHeaders () {
      return [
        { title: '生徒数', id: 'calc_acts', key: 17, yyyy: this.yyyy, align: 'start', prefix: '', suffix: '', color: '#BBDEFB80' },
        { title: '昨年', id: 'calc_acts_diff', key: 17, yyyy: this.yyyy - 1, align: 'end', prefix: '', suffix: this.value ? '%' : '', color: '' },
        { title: '目標', id: 'calc_acts_plans_diff', key: 17, yyyy: this.yyyy, align: 'end', prefix: '', suffix: this.value ? '%' : '', color: '' },
        { title: '問合せ数', id: 'calc_status', key: 1, yyyy: this.yyyy, align: 'start', prefix: '', suffix: '', color: '#F8BBD080' },
        { title: '入会率', id: 'calc_kpis_1', key: 6, yyyy: this.yyyy, align: 'start', prefix: '', suffix: '%', color: '#F8BBD080' },
        { title: '退会数', id: 'calc_status', key: 7, yyyy: this.yyyy, align: 'start', prefix: '', suffix: '', color: '#BBDEFB80' },
        { title: 'DTS', id: 'calc_status', key: 9, yyyy: this.yyyy, align: 'start', prefix: '', suffix: '', color: '#D7CCC880' },
        { title: '単価平均', id: 'calc_fees', key: 0, yyyy: this.yyyy, align: 'start', prefix: '¥', suffix: '', color: '#C8E6C980' }
      ]
    },
    groups () {
      var temp = []
      if (this.school) {
        var item = this.items[this.school.key]
        if (item) {
          temp = item.groups.map(function (g) {
            return { key: g.key, name: g.name }
          })
          temp.unshift({ key: '*', name: '全体' })
        }
      }
      return temp
    },
    details () {
      var temp = []
      if (this.school) {
        var item = this.items[this.school.key]
        if (item) {
          var groups = item.groups.map(function (g) {
            return { key: g.key, name: g.name }
          })
          groups.unshift({ key: '*', name: '全体' })
          for (var g in groups) {
            var data = []
            for (var i in this.detailHeaders) {
              var values = []
              var id = this.detailHeaders[i].id
              if ((id === 'calc_acts_diff' || id === 'calc_acts_plans_diff') && !this.value) {
                id = id === 'calc_acts_diff' ? 'calc_acts' : 'calc_plans_students'
                values = item[id][this.detailHeaders[i].yyyy]['*'].map(v => {
                  return v[this.detailHeaders[i].key]
                })
              } else {
                values = item[this.detailHeaders[i].id][this.detailHeaders[i].yyyy][groups[g].key].map(v => {
                  return v[this.detailHeaders[i].key]
                })
              }
              var status = item[id + '_sum'][this.detailHeaders[i].yyyy][groups[g].key][2][this.detailHeaders[i].key]
              if (this.detailHeaders[i].id === 'calc_status') {
                status = this.detailHeaders[i].key === 9 ? status.toFixed() : status.toFixed(1)
              }
              data.push({
                'key': id + this.detailHeaders[i].key + this.detailHeaders[i].yyyy,
                'title': this.detailHeaders[i].title,
                'align': this.detailHeaders[i].align,
                'values': values,
                'sum': status,
                'prefix': this.detailHeaders[i].prefix,
                'suffix': this.detailHeaders[i].suffix,
                'color': this.detailHeaders[i].color,
                'calc': 'ave'
              })
            }
            temp[groups[g].key] = data
          }
        }
      }
      return temp
    },
    contentsHeight () {
      return 'overflow-y: visible; height: ' + String(this.windowSize.y - 60 - 40 - 30 - 30) + 'px;'
    },
    contentsHeight2 () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 40 - 48) + 'px;'
    }
  },
  watch: {
    period () {
      this.createYears()
    }
  },
  data () {
    return {
      loading: false,
      items: [],
      item: null,
      skey: null,
      selected: null,
      options: [],
      period: 1,
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      school: null,
      schools: [],
      value: false, // true: value false: ratio'
      panel: [],
      group: null,
      setting: false,
      prev: false,
      plan: false
    }
  },
  created () {
    this.retrieve()
    this.createYears()
    this.selected = this.getFY()
  },
  methods: {
    async retrieve () {
      var vm = this
      this.items = []
      this.panel = []
      this.schools = []
      this.loading = true

      const functions = firebase.app().functions('asia-northeast1')
      const metrics = functions.httpsCallable('metrics')

      const db = firebase.firestore()
      var dbRef = db.collection('/schools')
      dbRef.get().then(function (snapshots) {
        for (var i in snapshots.docs) {
          var data = JSON.parse(JSON.stringify(snapshots.docs[i].data()))
          if (data.enable) {
            vm.schools.push(data)
          }
        }
        vm.schools.sort(function (a, b) {
          if (a.name > b.name) return 1
          if (a.name < b.name) return -1
          return 0
        })
        async.eachSeries(vm.schools, function (school, cb) {
          if (vm.checkSettings(school.key)) {
            metrics({ key: school.key }).then(function (result) {
              var keys = Object.keys(JSON.parse(JSON.stringify(result.data)))
              Vue.set(vm.items, keys[0], JSON.parse(JSON.stringify(result.data[keys[0]])))
              cb()
            })
          } else {
            cb()
          }
        }, function (error) {
          if (error) {
          }
          vm.loading = false
        })
      })
    },
    async oneRetrieve (item) {
      var vm = this
      this.loading = true
      const functions = firebase.app().functions('asia-northeast1')
      const metrics = functions.httpsCallable('metrics')
      metrics({ key: item.key }).then(function (result) {
        var keys = Object.keys(JSON.parse(JSON.stringify(result.data)))
        Vue.set(vm.items, keys[0], JSON.parse(JSON.stringify(result.data[keys[0]])))
        vm.loading = false
      }, function (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      })
    },
    checkSettings (key) {
      if (typeof this.data.diagnose === 'undefined') {
        return true
      }
      return this.data.diagnose[key]
    },
    createYears () {
      var year = 2018
      this.options = []
      if (this.period === 2) {
        year = 2019
        if (this.selected === 2018) {
          this.selected = 2019
        }
      }
      for (var y = year; y < this.getFY() + 1; y++) {
        this.options.push(
          { text: String(y), value: y }
        )
      }
    },
    groupNumber (item) {
      return item.groups.length
    },
    studentsPerGroup (students, g) {
      var num = Math.floor(students / g)
      if (isNaN(num) || num === Infinity) {
        num = 0
      }
      return num
    },
    students (type, item) {
      var num = 0
      var y = this.yyyy
      var m = this.mm
      if (typeof item.calc_acts[y] !== 'undefined') {
        if (typeof item.calc_acts[y]['*'][m] !== 'undefined') {
          num = item.calc_acts[y]['*'][m][17]
        }
      }
      if (type !== 'current') {
        if (type === 'prev') {
          y = this.yyyy - 1
          if (typeof item.calc_acts[y] !== 'undefined') {
            if (this.value) {
              if (typeof item.calc_acts[y]['*'][m] !== 'undefined') {
                num = Math.floor((num / item.calc_acts[y]['*'][m][17]) * 100)
              }
            } else {
              if (typeof item.calc_acts[y]['*'][m] !== 'undefined') {
                num = item.calc_acts[y]['*'][m][17]
              }
            }
          }
        } else if (type === 'plan') {
          if (typeof item.calc_plans[y] !== 'undefined') {
            if (this.value) {
              if (typeof item.calc_plans[y]['*'][m] !== 'undefined') {
                num = Math.floor((num / item.calc_plans[y]['*'][m][0]) * 100)
              }
            } else {
              num = item.calc_plans_students[y]['*'][m][17]
            }
          }
        }
      }
      if (isNaN(num) || num === Infinity) {
        num = 0
      }
      return num
    },
    status (type, item, y, m) {
      var num = 0
      var id = 'calc_status_sum'
      if (typeof item[id] !== 'undefined') {
        if (typeof item[id][y] !== 'undefined') {
          if (typeof item[id][y]['*'] !== 'undefined') {
            if (typeof item[id][y]['*'][2] !== 'undefined') {
              num = item[id][y]['*'][2][type]
            }
          }
        }
      }
      return num
    },
    kpi (type, item, y, m) {
      var num = 0
      if (typeof item.calc_kpis_1_sum[y] !== 'undefined') {
        if (typeof item.calc_kpis_1_sum[y]['*'] !== 'undefined') {
          if (typeof item.calc_kpis_1_sum[y]['*'][2] !== 'undefined') {
            num = item.calc_kpis_1_sum[y]['*'][2][type]
          }
        }
      }
      return num
    },
    fees (type, item, y, m) {
      var num = 0
      if (typeof item.calc_fees[y] !== 'undefined') {
        if (typeof item.calc_fees[y]['*'] !== 'undefined') {
          if (typeof item.calc_fees[y]['*'][m] !== 'undefined') {
            num = item.calc_fees[y]['*'][m][type]
          }
        }
      }
      return num
    },
    clickHeader (school) {
      this.school = null
      // this.$nextTick(function () {
      this.school = school
      // })
    },
    onPrint () {
      window.print()
    },
    onSelect (item, group) {
      this.group = group
      this.skey = item.key
      this.item = JSON.parse(JSON.stringify(this.items[item.key]))
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    },
    onDismissed () {
      this.setting = false
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style>
.scroller {
  height: 100%;
}
.customHeader {
  cursor: pointer;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.month-select {
  cursor: pointer;
}

.customLine:hover {
  background-color: #CCCCCC20;
}

.v-select__selections input { width: 0 }

.text-hidden {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
}

::-webkit-scrollbar { width: 0; }

.v-select__slot label {
  font-size: 0.875rem;
}

.outline {
  white-space: nowrap;
  overflow: hidden;
  border-radius: 4px;
  line-height: 14px !important;
  /* text-align: center; */
  vertical-align: middle !important;
  padding-left: 2px !important;
  padding-right: 2px !important;
  margin: 0px !important;
  border: 1px solid grey !important;
}

@media screen {
  .scroll-y {
    overflow-y: auto !important;
  }

  .b-B {
    border-bottom: 1px solid #1976D2 !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .b-L-GREY-DARK {
    border-left: 1px solid grey !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .b-R-GREY-DARK {
    border-right: 1px solid grey !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .b-B-GREY-DARK {
    border-bottom: 1px solid grey !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .b-B-GREY-DARK {
    border-bottom: 1px solid grey !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .b-BOX-GREY-DARK {
    border-top: 1px solid grey !important;
    border-bottom: 1px solid grey !important;
    border-left: 1px solid grey !important;
    border-right: 1px solid grey !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}

@media print {
  body {
    overflow: auto !important;;
    height: auto !important;;
    position: relative !important;
  }
  .print-btn {
    display: none;
  }
  .no-print {
    display: none;
  }
  .scroll-y {
    height: auto !important;;
    overflow: visible !important;
    overflow-y: visible !important;
    visibility: visible !important;
  }
  .b-L-GREY-DARK {
    border-left: 1px solid grey !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .b-R-GREY-DARK {
    border-right: 1px solid grey !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .b-B-GREY-DARK {
    border-bottom: 1px solid grey !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .b-BOX-GREY-DARK {
    border-top: 1px solid grey !important;
    border-bottom: 1px solid grey !important;
    border-left: 1px solid grey !important;
    border-right: 1px solid grey !important;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}

.my-footer {
  bottom: 0;
  position: fixed;
  right: 0;
}

</style>
